module.exports = __webpack_public_path__ + "img/img_nav_service-w.4df84a47.svg";